import React from 'react';
import useAppContent from '../../../hooks/useAppContent';
import QuestionSlide from '../QuestionSlide/QuestionSlide';

const Slide4 = ({ canProceed = true }) => {
  const { appContent, loading } = useAppContent();

  const questionData = {
    questionId: 'q2',
    title: appContent?.acf?.slide_4_title,
    description: appContent?.acf?.slide_4_description,
    options: processQuestionOptions(appContent?.acf?.slide_4_question_answers)
  };

  if (loading) {
    return (
      <div className="slide slide4">
        <div className="slide4__loading">
          <div className="spinner"></div>
          <p>Loading question...</p>
        </div>
      </div>
    );
  }

  return (
    <QuestionSlide
      questionId={questionData.questionId}
      title={questionData.title}
      description={questionData.description}
      options={questionData.options}
      canProceed={canProceed}
    />
  );
};

const processQuestionOptions = (acfOptions) => {
  if (!acfOptions || !Array.isArray(acfOptions)) {
    return [];
  }

  return acfOptions.map((option, index) => ({
    value: option.value || `option_${index + 1}`,
    label: option.answer || `Option ${index + 1}`,
    description: option.description || ''
  }));
};

export default Slide4;
